export const layoutResources = {
  'layout.header.accountDropdownTitle': 'Account Settings',
  'layout.notifications.clearNotifications': 'Clear Acknowledged Notifications',
  'layout.footer.copyright': 'Copyright Shipium',
};

export type LayoutResourceKey =
  | 'layout.header.accountDropdownTitle'
  | 'layout.notifications.clearNotifications'
  | 'layout.footer.copyright';
